module.exports = __webpack_public_path__ + "media/images/350x150-1-265698a6307ba17de00a872fc2d4c2c9.jpg";